import { render, staticRenderFns } from "./teststatistick.vue?vue&type=template&id=67ce3732&"
import script from "./teststatistick.vue?vue&type=script&lang=js&"
export * from "./teststatistick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports